import { Card, CardContent } from "../../features/ui/card";
import { Skeleton } from "../../features/ui/skeleton";


export const EventsCardSkeleton: React.FC = () => (
 
    <>
    <CardContent className="flex-1 p-0">
            <div className="space-y-3 p-4">
                {[...Array(3)].map((_, i) => (
                    <Card key={i} className="border-l-4">
                        <CardContent className="p-5">
                            <Skeleton className="h-5 w-40 mb-2" />
                            <Skeleton className="h-4 w-32 mb-2" />
                            <div className="flex items-center space-x-2 mb-2">
                                <Skeleton className="h-3 w-12 rounded-full" />
                                <Skeleton className="h-3 w-20" />
                            </div>
                            <div className="grid grid-cols-3 gap-3 mb-3">
                                <Skeleton className="h-8 w-full rounded-lg" />
                                <Skeleton className="h-8 w-full rounded-lg" />
                                <Skeleton className="h-8 w-full rounded-lg" />
                            </div>
                            <div className="grid grid-cols-2 gap-3">
                                <Skeleton className="h-8 w-full rounded-lg" />
                                <Skeleton className="h-8 w-full rounded-lg" />
                            </div>
                        </CardContent>
                    </Card>
                ))}
            </div>
    </CardContent>
    </>
 
);